import { StoreBase } from "imagica-corekit/dist/base/cutil/StoreBase";

type Param = Partial<Omit<PreviewPaneStoreState, "copyWith">>;
export class PreviewPaneStoreState {
  settingPageStatus = false;
  openTitleIconTooltip = false;

  copyWith(params: Param): PreviewPaneStoreState {
    const state = new PreviewPaneStoreState();
    state.settingPageStatus = params.settingPageStatus ?? this.settingPageStatus;
    state.openTitleIconTooltip = params.openTitleIconTooltip ?? this.openTitleIconTooltip;

    return state;
  }
}

export class PreviewPaneStore extends StoreBase<PreviewPaneStoreState> {
  constructor() {
    super(() => {
      return new PreviewPaneStoreState();
    });
  }

  private setState(param: Param) {
    let newState = this.state.copyWith(param);
    this.emit(newState);
  }
  settingPageStatus(settingPageStatus: boolean) {
    this.setState({ settingPageStatus });
  }
  openTitleIconTooltip(openTitleIconTooltip: boolean) {
    this.setState({ openTitleIconTooltip });
  }
}
